import api from '../axios';
/* eslint-disable */
export const apiGetUserLikeList = params => api.post('/vod/user/praise/list', params);
// 获取别人发布的视频列表
export const apiGetUserWorksList = params => api.post('/vod/user/list', params);
export const apiGetUserLiveList = params => api.post('/live/getLiveVideoList', params);
// 获取开始直播时间
export const apiGetLiveTime = params => api.post('/user/live/notice/find', params);
// 获取用户信息
export const apiGetUserCenterInfo = params => api.post('/user/homepage/other/get', params);
// 拉黑状态
export const apiGetUserBlackState = params => api.post('/user/blacklist/state', params);
